import { Component } from 'react'
import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import type { Group } from 'types/group'
import {
  loadLibrary,
  openGroupLink,
} from '@disco/state-management/actions/ExplorerActions'
import { getGroup } from '@disco/state-management/selectors/groups'
import type { RootState } from 'store/configureStore'

function mapStateToProps(
  state: RootState,
  props: { params: { groupId: string } },
) {
  return {
    group: getGroup(state, {
      groupId: parseInt(props.params.groupId),
    }),
  }
}

const mapDispatchToProps = {
  loadLibrary,
  openGroupLink,
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  params: {
    groupId: string
  }
  navigate: NavigateFunction
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class GroupLink extends Component<Props> {
  _redirectToGroup = (group: Group) => {
    this.props.loadLibrary(group)
    this.props.navigate('/')
  }

  componentDidMount() {
    // add empty pane with loading state
    this.props.openGroupLink()

    if (this.props.group) {
      this._redirectToGroup(this.props.group)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (
      this.props.params.groupId !== nextProps.params.groupId ||
      this.props.group !== nextProps.group
    ) {
      this._redirectToGroup(nextProps.group)
    }
  }

  render() {
    return null
  }
}

const ConnectedGroupLink = connector(GroupLink)

// Wrapper component to provide both router params and navigation to the connected component
const GroupLinkWithRouter = (props: any) => {
  const params = useParams<{ groupId: string }>()
  const navigate = useNavigate()

  return <ConnectedGroupLink {...props} params={params} navigate={navigate} />
}

export default GroupLinkWithRouter
